import { useEffect } from 'react';

const snowflakeSymbols = ['🌷', '🎁', '🌺', '💖'];

const random = (min, max) => Math.random() * (max - min) + min;

export default function Snowfall({ active }) {
  useEffect(() => {
    if (!active) return;

    const snowflakes = [];
    const snowflakeCount = 80;

    function createSnowflake() {
      const snowflake = document.createElement('div');
      snowflake.className = 'snowflake';
      snowflake.innerText = snowflakeSymbols[Math.floor(Math.random() * snowflakeSymbols.length)];

      snowflake.style.left = `${random(0, 100)}vw`;
      snowflake.style.fontSize = `${random(0.8, 2)}em`;
      snowflake.style.opacity = random(0.5, 1);
      snowflake.style.animationDuration = `${random(10, 25)}s`;
      snowflake.style.animationDelay = `${random(0, 10)}s`;

      snowflake.style.setProperty('--horizontal-drift', `${random(-15, 15)}vw`);
      snowflake.style.setProperty('--rotation', `${random(-360, 360)}deg`);

      if (Math.random() > 0.8) {
        snowflake.classList.add('flare');
      }

      document.body.appendChild(snowflake);
      snowflakes.push(snowflake);

      snowflake.addEventListener('animationend', () => {
        snowflake.remove();
      });
    }

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < snowflakeCount; i++) {
      createSnowflake();
    }

    const interval = setInterval(createSnowflake, 500);
    // eslint-disable-next-line consistent-return
    return () => {
      clearInterval(interval);
      snowflakes.forEach((flake) => flake.remove());
    };
  }, [active]);

  return null;
}
